export enum OKVItemType {
  Product = 'product',
  Category = 'category',
  Series = 'series',
}

export type BackgroundColor = 'white' | 'blue-grey' | 'light-grey' | 'medium-grey';

export interface OKVItem {
  identifier: string;
  catalogLocale: string;
  type: OKVItemType;
  product?: OKVProduct;
}

interface ProductStateProps {
  bimReady: boolean;
  bimRelevant: boolean;
  buyable: boolean;
  from: unknown;
  indicator: string | null;
  orderRelated: boolean;
  replacedBy: unknown;
  replacementFor: unknown;
}

export interface OKVProduct {
  key: string;
  deprecated?: boolean;
  categoryId: string;
  gallery?: {
    list?: any[];
  };
  pictureObject: PictureObject;
  pictureObjectMobile: PictureObjectMobile;
  name: string;
  state: ProductStateProps;
  description: string;
  numberArticles: number;
  articles: {
    articlesListSize: number;
  };
  title: string;
  subtitle: string;
  categories: OKVCategory[];
}

export interface OKVTile extends OKVItem {
  product: OKVProduct;
  filterProductThumbnails: () => null;
  total: number;
  catalogLanguage: string;
}

export type OKVJsonContent<T extends OKVItem = OKVItem> = {
  items: T[];
  title?: string;
};

export interface CategoryTreeRoot {
  id: string;
  name: string;
  subCategories: OKVCategory[];
  hasProducts: boolean;
  hasSpareParts: boolean;
}

export type OKVCategory = {
  id: string;
  uuid: string;
  name: string;
  hasProducts: boolean;
  hasSpareParts: boolean;
  orderHint: string;
  subCategories?: OKVCategory[];
  ancestors: Ancestor[];
  total?: number;
  slogan?: string;
  description?: string;
  overviews?: Overview[];
} & OKVCategoryImage;

type OKVCategoryImage =
  | {
      categoryType: OKVItemType.Series;
      images: SeriesImage[];
    }
  | {
      categoryType: OKVItemType.Category | OKVItemType.Product;
      images: CategoryImage[];
    };

interface CategoryImage {
  key: string;
  thumbnail: string;
  orientation: string;
  sequence: number;
}

interface SeriesImage extends CategoryImage {
  small?: string;
  medium?: string;
  large?: string;
}

interface Overview {
  name: string;
  url: string;
}

type Ancestor = {
  uid: string;
  id: string;
  name: string;
};
